import AlignmentMenuItem from './alignment-menu-item';

import HelptapEditor from '../helpers';

export function normalizeFourSideValues(values, type) {

  if (Array.isArray(values) === true) {
    return values;
  }

  return [0, 0, 0, 0];

}

export function normalizeWidthHeightValues(values) {
  let { width, height } = values;

  if (typeof width === 'undefined') {
    width = 0;
  }

  if (typeof height === 'undefined') {
    height = 0;
  }

  return [width, height];

}

export function determineAlignmentType(values) {

  let alignment = AlignmentMenuItem.types.LEFT;
  let marginLeft = values.marginLeft;
  let marginRight = values.marginRight;

  if (marginLeft === 'auto' && marginRight === 'auto') {
    alignment = AlignmentMenuItem.types.CENTER;
  } else if (marginLeft === void 0 && marginRight === void 0) {
    alignment = AlignmentMenuItem.types.CENTER;
  }

  if (marginLeft === 'auto' && (typeof marginRight === 'undefined' || marginRight === null)) {
    alignment = AlignmentMenuItem.types.RIGHT;
  }

  if ((typeof marginLeft === 'undefined' || marginLeft === null) && marginRight === 'auto') {
    alignment = AlignmentMenuItem.types.LEFT;
  }

  return alignment;

}

export function getColumns(node, columnsCount) {

  let columns = [...node.children];

  if (columns.length > columnsCount) {

    columns = columns.slice(0, columnsCount);

  } else {
    for (let index = columns.length; index < columnsCount; index++) {

      columns.push(HelptapEditor.buildColumBlockOptions(index));

    }
  }

  const columnsLength = columns.length;
  const width = 100 / columnsLength;

  for (let index = 0; index < columnsLength; index++) {

    const column = columns[index];

    columns[index] = {
      ...column,
      width
    };

  }

  return columns;

}

export function buildBackgroundProperties(background) {

  const result = {
    backgroundColor: background.color,
    backgroundImage: background.image,
    backgroundPosition: background.position,
    backgroundSize: background.size,
  };

  return result;

}